import { Button, Group, List, Modal, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useDisclaimer } from "src/contexts/DisclaimerContext";
import { useArtifactHandler } from "src/utils/artifactHandler";

export function DisclaimerModal() {
    const { isOpen, messages, link, closeDisclaimer } = useDisclaimer();
    const { openUrl } = useArtifactHandler();

    const handleOpenLink = () => {
        closeDisclaimer();
        openUrl(link);
    };

    return (
        <Modal opened={isOpen} onClose={closeDisclaimer} title="⚠️ Warning" centered>
            <Stack gap="sm">
                <List
                    spacing="xs"
                    icon={
                        <ThemeIcon color="red" radius="xl" size="sm">
                            <IconAlertTriangle size={16} />
                        </ThemeIcon>
                    }
                >
                    {messages.map((msg) => (
                        <List.Item key={msg}>
                            <Text color="red">{msg}</Text>
                        </List.Item>
                    ))}
                </List>
                <Group justify="flex-end" mt="md">
                    <Button variant="default" onClick={closeDisclaimer}>
                        Cancel
                    </Button>
                    <Button data-testid="confirm-open-link" color="red" onClick={handleOpenLink}>
                        I Understand, Open Link
                    </Button>
                </Group>
            </Stack>
        </Modal>
    );
}
